import { render } from "./VosQuality.vue?vue&type=template&id=82ea0b88&scoped=true"
import script from "./VosQuality.vue?vue&type=script&lang=js"
export * from "./VosQuality.vue?vue&type=script&lang=js"

import "./VosQuality.vue?vue&type=style&index=0&id=82ea0b88&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ea0b88"]])

export default __exports__